// eslint-disable-next-line max-classes-per-file
import type { ResponseInterface } from "../../common/commonInterface";

export interface RequestGetTicketAvailableInterface {
  ticketId?: number;
  countrySlug?: string;
  citySlug?: string;
  slug?: string;
}

export interface RequestGetEventAvailableInterface {
  categorySlug?: string;
  subCategorySlug?: string;
  sportTeamSlug?: string;
  eventId?: string;
}

export enum TicketType {
  GENERAL = "general",
  EVENT = "event",
  DAY_TRIP = "daytrip",
  TICKET = "ticket",
  CONCERTs = "concerts",
  FOOTBALL = "football",
  GOLF = "golf",
  F1 = "f1",
  TENNIS = "tennis",
  VOUCHER = "voucher",
}

export enum CategorySlug {
  SPARELAX = "spa-relax",
  CONCERTS = "concerts",
  HEALTHBEAUTY = "health-beauty",
  FOOTBALL = "football",
  GOLF = "golf",
  F1 = "f1",
  TENNIS = "tennis",
  ENTERTAINMENT = "entertainment",
  EXHIBITION = "exhibition",
}

export enum TierType {
  EXCLUSIVE = "exclusive",
}
export interface TicketAvailableKlubCategory {
  name: string;
  slug: string;
}
export interface ResponseGetEventTicketAvailableInterface {
  name: string;
  isJoin: boolean;
  isSEO: boolean;
  bestSeller: boolean;
  topRating: boolean;
  klubCategory: TicketAvailableKlubCategory;
  categorySlug: string[];
  country: string;
  specialDiscount: string;
  tier: string;
  isFixedDate: boolean;
  ticketType: string;
  packages: TicketAvailablePackage[];
}

export interface TicketAvailableSubPackage {
  name: string;
  key: string;
  isPrivate: boolean;
  maxPax: number;
  minPax: number;
  meetingPoint: TicketAvailableMeetingPoint[];
  fixedDates: string[];
  freeCancellation: boolean;
  eventId: string;
  nameOg: string;
  eventName: string;
  eventGuest: string;
  deliveryDescription: string;
  seatingDescription: string;
  hospitalityDescription: string;
  date: string;
  time: string;
  categoryId: string;
  categorySlug: string;
  categoryName: string;
  subCategoryId: string;
  subCategorySlug: string;
  subCategoryName: string;
  location: string;
  city: string;
  country: string;
  prices: TicketAvailablePrice[];
  stock: number;
  image: string;
  inclusions: string | null;
}

export interface TicketAvailableItineraryDetail {
  photoPath: string[];
  detail: string;
  time: string;
  day: number | null;
  addressDetail: string;
  airportId: number;
  countryId: number;
  areaId: number;
  cityId: number;
}

export interface TicketAvailableMeetingPoint {
  id: number;
  name: string;
  address: string;
  location: TicketAvailableLocation;
  isCustom: boolean;
}
export interface TicketAvailableLocation {
  latitude: number;
  longitude: number;
}
export type TicketAvailableTermsAndCondition = string;

export interface TicketAvailablePackage {
  key: string;
  name: string;
  description: string | null;
  howToUse: string | null;
  termsAndConditions: TicketAvailableTermsAndCondition | null;
  redeemStart: string;
  redeemEnd: string;
  currency: string;
  instantConfirm: boolean;
  maxPax: number;
  minPax: number;
  guestQuestions: any;
  questions: TicketAvailableQuestion[];
  itineraryDetail: TicketAvailableItineraryDetail[];
  meetingPoint: TicketAvailableMeetingPoint[];
  photoPath: string;
  freeCancellation: boolean;
  cancellationPolicy: string;
  prices: TicketAvailablePrice[];
  isFixedDate: boolean;
  isDeposit: boolean;
  wholesaleCode: any;
  eventId: string;
  eventName: string;
  eventGuest: string;
  deliveryDescription: string;
  seatingDescription: string;
  hospitalityDescription: string;
  date: string;
  time: string;
  category: TicketAvailablePackageCategory;
  subCategory: TicketAvailablePackageCategory;
  sportTeam: TicketAvailablePackageCategory;
  location: string;
  city: TicketAvailablePackageCategory;
  country: TicketAvailablePackageCategory;
  subPackages: TicketAvailableSubPackage[];
}
export interface TicketAvailablePackageCategory {
  id: string;
  slug: string;
  name: string;
}

export interface TicketAvailableQuestion {
  id: number;
  question: string;
  options: string[];
  optional: boolean;
  type: TicketAvailableQuestionType;
}

export interface TicketAvailableQuestionType {
  enumType: string;
  name: string;
}
export enum FrequencyTypeEnum {
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  EVERYDAY = "everyday",
}

export interface TicketAvailablePriceAvailabilityDates {
  date: string;
  minPax: number;
  maxPax: number;
}
export interface TicketAvailablePriceAvailability {
  isOpenDated: boolean;
  dates: TicketAvailablePriceAvailabilityDates[];
}
export interface TicketAvailablePrice {
  id: number;
  type: string;
  nameEn: string;
  nameTh: string;
  priceIndex: number;
  priceCount: number;
  isBundleDeal: boolean;
  price: number;
  prices: number[];
  originalPrice: number;
  exclusivePrice: number;
  exclusivePrices: number[];
  settlementPrice: number;
  settlementPrices: number[];
  currency: string;
  minPax: number;
  maxPax: number;
  frequency: string;
  span: number[];
  fixedDates: string[];
  expirationDate: number;
  sku: string;
  name: string;
  image: string;
  stock: number;
  shippingCosts: number;
  settlementCurrency: string;
  remainingPrice: number;
  remainingPrices: number[];
  personPerpax: number;
  blockoutDates: string[];
  availability: TicketAvailablePriceAvailability;
}

class GetTicketAvailablePriceAvailabilityDate {
  date: string;

  minPax: number;

  maxPax: number;

  constructor(data: TicketAvailablePriceAvailabilityDates) {
    this.date = data?.date || "";
    this.minPax = data?.minPax || 0;
    this.maxPax = data?.maxPax || 0;
  }
}
class GetTicketAvailablePriceAvailability {
  isOpenDated: boolean;

  dates: TicketAvailablePriceAvailabilityDates[];

  constructor(data: TicketAvailablePriceAvailability) {
    this.isOpenDated =
      data?.isOpenDated === undefined ? true : data?.isOpenDated;
    this.dates = (data?.dates || [])?.map(
      (item) => new GetTicketAvailablePriceAvailabilityDate(item),
    );
  }
}
class GetTicketAvailableQuestion {
  id: number;

  question: string;

  options: string[];

  optional: boolean;

  type: TicketAvailableQuestionType;

  constructor(data: TicketAvailableQuestion) {
    this.id = data?.id || 0;
    this.question = data?.question || "";
    this.options = data?.options || [];
    this.optional = data?.optional || false;
    this.type = data?.type || { enumType: "", name: "" };
  }
}
class GetTicketAvailablePrice {
  id: number;

  type: string;

  nameEn: string;

  nameTh: string;

  priceIndex: number;

  priceCount: number;

  isBundleDeal: boolean;

  price: number;

  prices: number[];

  originalPrice: number;

  exclusivePrice: number;

  exclusivePrices: number[];

  settlementPrice: number;

  settlementPrices: number[];

  currency: string;

  minPax: number;

  maxPax: number;

  frequency: string;

  span: number[];

  fixedDates: string[];

  expirationDate: number;

  sku: string;

  name: string;

  image: string;

  stock: number;

  shippingCosts: number;

  settlementCurrency: string;

  remainingPrice: number;

  remainingPrices: number[];

  personPerpax: number;

  blockoutDates: string[];

  availability: TicketAvailablePriceAvailability;

  constructor(data: TicketAvailablePrice) {
    this.id = data?.id || 0;
    this.type = data?.type || "";
    this.nameEn = data?.nameEn || "";
    this.nameTh = data?.nameTh || "";
    this.price = data?.price || 0;
    this.originalPrice = data?.originalPrice || 0;
    this.exclusivePrice = data?.exclusivePrice || 0;
    this.settlementPrice = data?.settlementPrice || 0;
    this.currency = data?.currency || "";
    this.minPax = data?.minPax || 1;
    this.maxPax = data?.maxPax || 9;
    this.frequency = data?.frequency || "everyday";
    this.span = data?.span || [];
    this.fixedDates = data?.fixedDates || [];
    this.expirationDate = data?.expirationDate || 0;
    this.isBundleDeal = data?.isBundleDeal || false;
    this.priceIndex = data?.priceIndex || 0;
    this.priceCount = data?.priceCount || 0;
    this.prices = data?.prices || [];
    this.exclusivePrices = data?.exclusivePrices || [];
    this.sku = data?.sku || "";
    this.name = data?.name || "";
    this.image = data?.image || "";
    this.stock = data?.stock || 0;
    this.shippingCosts = data?.shippingCosts || 0;
    this.settlementPrices = data?.settlementPrices || [];
    this.settlementCurrency = data?.settlementCurrency || "";
    this.remainingPrice = data?.remainingPrice || 0;
    this.remainingPrices = data?.remainingPrices || [];
    this.personPerpax = data?.personPerpax || 0;
    this.blockoutDates = data?.blockoutDates || [];
    this.availability = new GetTicketAvailablePriceAvailability(
      data?.availability,
    );
  }
}

class GetTicketAvailableMeetingPoint {
  id: number;

  name: string;

  address: string;

  location: TicketAvailableLocation;

  isCustom: boolean;

  constructor(data: TicketAvailableMeetingPoint) {
    this.id = data?.id || 0;
    this.name = data?.name || "";
    this.address = data?.address || "";
    this.location = data?.location || { latitude: 0, longitude: 0 };
    this.isCustom = data?.isCustom || false;
  }
}

class GetTicketAvailableSubPackage {
  name: string;

  key: string;

  meetingPoint: TicketAvailableMeetingPoint[];

  isPrivate: boolean;

  maxPax: number;

  minPax: number;

  fixedDates: string[];

  freeCancellation: boolean;

  eventId: string;

  nameOg: string;

  eventName: string;

  eventGuest: string;

  deliveryDescription: string;

  seatingDescription: string;

  hospitalityDescription: string;

  date: string;

  time: string;

  categoryId: string;

  categorySlug: string;

  categoryName: string;

  subCategoryId: string;

  subCategorySlug: string;

  subCategoryName: string;

  location: string;

  city: string;

  country: string;

  stock: number;

  image: string;

  prices: TicketAvailablePrice[];

  inclusions: string | null;

  constructor(data: TicketAvailableSubPackage) {
    this.name = data?.name || "";
    this.key = data?.key || "";
    this.meetingPoint = (data?.meetingPoint || [])?.map(
      (item) => new GetTicketAvailableMeetingPoint(item),
    );
    this.isPrivate = data?.isPrivate || false;
    this.minPax = data?.minPax || 1;
    this.maxPax = data?.maxPax || 9;
    this.fixedDates = data?.fixedDates || [];
    this.freeCancellation = data?.freeCancellation || false;
    this.eventId = data?.eventId || "";
    this.nameOg = data?.nameOg || "";
    this.eventName = data?.eventName || "";
    this.eventGuest = data?.eventGuest || "";
    this.deliveryDescription = data?.deliveryDescription || "";
    this.seatingDescription = data?.seatingDescription || "";
    this.hospitalityDescription = data?.hospitalityDescription || "";
    this.date = data?.date || "";
    this.time = data?.time || "";
    this.categoryId = data?.categoryId || "";
    this.categorySlug = data?.categorySlug || "";
    this.categoryName = data?.categoryName || "";
    this.subCategoryId = data?.subCategoryId || "";
    this.subCategorySlug = data?.subCategorySlug || "";
    this.subCategoryName = data?.subCategoryName || "";
    this.location = data?.location || "";
    this.city = data?.city || "";
    this.country = data?.country || "";
    this.stock = data?.stock || 0;
    this.image = data?.image || "";
    this.prices = (data?.prices || [])?.map(
      (item) => new GetTicketAvailablePrice(item),
    );
    this.inclusions = data?.inclusions || null;
  }
}

class GetTicketAvailableItineraryDetail {
  photoPath: string[];

  detail: string;

  day: number | null;

  time: string;

  addressDetail: string;

  airportId: number;

  countryId: number;

  areaId: number;

  cityId: number;

  constructor(data: TicketAvailableItineraryDetail) {
    this.photoPath = data?.photoPath || "";
    this.detail = data?.detail || "";
    this.time = data?.time || "";
    this.day = data?.day || null;
    this.addressDetail = data?.addressDetail || "";
    this.airportId = data?.airportId || 0;
    this.countryId = data?.countryId || 0;
    this.areaId = data?.areaId || 0;
    this.cityId = data?.cityId || 0;
  }
}
class GetTicketAvailablePackageCategory {
  id: string;

  name: string;

  slug: string;

  constructor(data: TicketAvailablePackageCategory) {
    this.id = data?.id || "";
    this.name = data?.name || "";
    this.slug = data?.slug || "";
  }
}
class GetTicketAvailablePackage {
  key: string;

  name: string;

  description: string | null;

  howToUse: string | null;

  termsAndConditions: TicketAvailableTermsAndCondition | null;

  redeemStart: string;

  redeemEnd: string;

  currency: string;

  maxPax: number;

  minPax: number;

  instantConfirm: boolean;

  guestQuestions: any;

  questions: TicketAvailableQuestion[];

  itineraryDetail: TicketAvailableItineraryDetail[];

  meetingPoint: TicketAvailableMeetingPoint[];

  photoPath: string;

  freeCancellation: boolean;

  cancellationPolicy: string;

  prices: TicketAvailablePrice[];

  isFixedDate: boolean;

  isDeposit: boolean;

  wholesaleCode: any;

  eventId: string;

  eventName: string;

  eventGuest: string;

  deliveryDescription: string;

  seatingDescription: string;

  hospitalityDescription: string;

  date: string;

  time: string;

  category: TicketAvailablePackageCategory;

  subCategory: TicketAvailablePackageCategory;

  sportTeam: TicketAvailablePackageCategory;

  location: string;

  city: TicketAvailablePackageCategory;

  country: TicketAvailablePackageCategory;

  subPackages: TicketAvailableSubPackage[];

  constructor(data: TicketAvailablePackage) {
    this.key = data?.key || "";
    this.name = data?.name || "";
    this.description = data?.description || null;
    this.howToUse = data?.howToUse || null;
    this.termsAndConditions = data?.termsAndConditions || null;
    this.redeemStart = data?.redeemStart || "";
    this.redeemEnd = data?.redeemEnd || "";
    this.currency = data?.currency || "";
    this.instantConfirm = data?.instantConfirm || false;
    this.maxPax = data?.maxPax || 9;
    this.minPax = data?.minPax || 0;
    this.guestQuestions = data?.guestQuestions || {};
    this.questions = (data?.questions || [])?.map(
      (item) => new GetTicketAvailableQuestion(item),
    );
    this.itineraryDetail = (data?.itineraryDetail || [])?.map(
      (item) => new GetTicketAvailableItineraryDetail(item),
    );
    this.meetingPoint = (data?.meetingPoint || [])?.map(
      (item) => new GetTicketAvailableMeetingPoint(item),
    );
    this.photoPath = data?.photoPath || "";
    this.freeCancellation = data?.freeCancellation || false;
    this.cancellationPolicy = data?.cancellationPolicy || "";
    this.isFixedDate = data?.isFixedDate || false;
    this.isDeposit = data?.isDeposit || false;
    this.eventId = data?.eventId || "";
    this.eventName = data?.eventName || "";
    this.eventGuest = data?.eventGuest || "";
    this.deliveryDescription = data?.deliveryDescription || "";
    this.seatingDescription = data?.seatingDescription || "";
    this.hospitalityDescription = data?.hospitalityDescription || "";
    this.date = data?.date || "";
    this.time = data?.time || "";
    this.category = new GetTicketAvailablePackageCategory(data?.category);
    this.subCategory = new GetTicketAvailablePackageCategory(data?.subCategory);
    this.sportTeam = new GetTicketAvailablePackageCategory(data?.sportTeam);
    this.city = new GetTicketAvailablePackageCategory(data?.city);
    this.country = new GetTicketAvailablePackageCategory(data?.country);

    this.location = data?.location || "";
    this.prices = (data?.prices || [])?.map(
      (item) => new GetTicketAvailablePrice(item),
    );
    this.subPackages = (data?.subPackages || [])?.map(
      (item) => new GetTicketAvailableSubPackage(item),
    );
  }
}
class GetEventTicketAvailable {
  name: string;

  klubCategory: TicketAvailableKlubCategory;

  tier: string;

  isJoin: boolean;

  isSEO: boolean;

  bestSeller: boolean;

  topRating: boolean;

  isFixedDate: boolean;

  ticketType: string;

  categorySlug: string[];

  country: string;

  specialDiscount: string;

  packages: GetTicketAvailablePackage[];

  constructor(data: ResponseGetEventTicketAvailableInterface) {
    this.name = data?.name || "";
    this.klubCategory = data?.klubCategory || { name: "", slug: "" };
    this.tier = data?.tier || "";
    this.isJoin = data?.isJoin || false;
    this.isSEO = data?.isSEO || false;
    this.bestSeller = data?.bestSeller || false;
    this.topRating = data?.topRating || false;
    this.isFixedDate = data?.isFixedDate || false;
    this.ticketType = data?.ticketType || "";
    this.categorySlug = data?.categorySlug || [];
    this.country = data?.country || "";
    this.specialDiscount = data?.specialDiscount || "";
    this.packages = (data?.packages || [])?.map(
      (item) => new GetTicketAvailablePackage(item),
    );
  }
}
export class ResponseGetEventTicketAvailable {
  status: boolean;

  message: string;

  data: ResponseGetEventTicketAvailableInterface;

  constructor(
    response: ResponseInterface<ResponseGetEventTicketAvailableInterface>,
  ) {
    this.status = response.status || false;
    this.message = response.message || "";
    this.data = new GetEventTicketAvailable(response.data);
  }
}
